import styled from '@emotion/styled';
import { mediaQueries } from '../../../../style/global-style';

export const StyledRatingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: ${(props) => props.theme.shades.blackGrey};

    @media ${mediaQueries.tabletAndUp} {
        align-items: center;
        flex-direction: column;
    }
`;

export const StyledRatingValueBox = styled.div`
    background-color: ${(props) => props.theme.colors.main4};
    color: ${(props) => props.theme.shades.white};
    font-weight: 400;
    font-size: ${(props) => props.theme.fontSize.headlineS};
    display: flex;
    justify-content: center;
    align-items: baseline;
    padding: 10px;

    @media ${mediaQueries.tabletAndUp} {
        font-size: 26px; //not in fontsizes
        padding: 5px 35px;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        font-size: 28px; //not in fontsizes
    }
`;

export const StyledRatingValue = styled.span`
    font-size: ${(props) => props.theme.fontSize.headlineS};
    font-weight: 700;
    padding-right: 10px;

    @media ${mediaQueries.tabletAndUp} {
        font-size: 50px; //not in fontsizes
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        font-size: 52px; //not in fontsizes
    }
`;

export const StyledArrow = styled.div`
    width: 0;
    height: 0;
    border-left: 8px solid ${(props) => props.theme.colors.main4};
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;

    @media ${mediaQueries.tabletAndUp} {
        border-right: 15px solid transparent;
        border-top: 10px solid ${(props) => props.theme.colors.main4};
        border-left: 15px solid transparent;
    }
`;

export const StyledRatingString = styled.span`
    font-size: 22px; //not in global sizes
    font-weight: 700;
    padding-bottom: 2px;
    @media ${mediaQueries.tabletAndUp} {
        font-size: 36px; // not in global sizes
        padding-bottom: 5px;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        font-size: 38px; // not in global sizes
    }
`;

export const StyledAmountOfRatings = styled.span`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    font-weight: 400;

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextL};
    }
`;

export const StyledContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;

    @media ${mediaQueries.tabletAndUp} {
        align-items: center;
        margin-left: 0;
    }
`;
